var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-323 -435.935)"},React.createElement("path",{"fill":"currentColor","stroke":"none","data-name":"Soustraction 2","d":"M-1479-3588h-10a5.006,5.006,0,0,1-5-5v-10a5.006,5.006,0,0,1,5-5h10a5.006,5.006,0,0,1,5,5v10A5.006,5.006,0,0,1-1479-3588Zm-4.957-14.044a3.979,3.979,0,0,0-3.572,2.2,3.992,3.992,0,0,0,.744,4.627,3.979,3.979,0,0,0,2.83,1.172,4.024,4.024,0,0,0,1.8-.427,3.993,3.993,0,0,0,2.158-4.16,3.97,3.97,0,0,0-1.128-2.241,3.975,3.975,0,0,0-2.241-1.129A4.033,4.033,0,0,0-1483.957-3602.043Zm6-2.871a1,1,0,0,0-.893.551,1,1,0,0,0,.187,1.157.992.992,0,0,0,.706.292,1.012,1.012,0,0,0,.45-.107,1,1,0,0,0,.54-1.04,1,1,0,0,0-.842-.843A1.017,1.017,0,0,0-1477.957-3604.914Z","transform":"translate(1817 4043.935)"})));
}

Instagram.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Instagram;

Instagram.default = Instagram;
